const BYear = [
    {id: "0", value: "今年"},
    {id: "1", value: "1年前"},    
    {id: "2", value: "2年前"},
    {id: "3", value: "3年前"},    
    {id: "4", value: "4年前"},
    {id: "5", value: "5年前"},
];  
  
  export default BYear